import {translations} from 'presentation/translations-new';

const {confirm, professional, specialty, unit, location, neighborhood} =
	translations['pt-br'].privateFlow.bookingFlow.steps;

const ODONTO_LABELS = [location, specialty, neighborhood, unit, professional, confirm];
const ODONTO_LABELS_WITHOUT_DISTRICT = [location, specialty, unit, professional, confirm];

export {ODONTO_LABELS, ODONTO_LABELS_WITHOUT_DISTRICT};
